import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { ArrowLeft, ArrowCounterClockwise, Trash } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function FormulasTrash() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        setLoading(true);
        try {
            const r = await api.get("/formulas/trash");
            setItems(r.data);
        } catch {
            toast.error("No se pudo cargar la papelera");
        } finally { setLoading(false); }
    };
    useEffect(() => { load(); }, []);

    const restore = async (id) => {
        try {
            await api.post(`/formulas/${id}/restore`);
            toast.success("Fórmula restaurada");
            load();
        } catch {
            toast.error("No se pudo restaurar");
        }
    };

    const purge = async (id, title) => {
        if (!window.confirm(`Eliminar PERMANENTEMENTE "${title}"? Esta acción no se puede deshacer.`)) return;
        try {
            await api.delete(`/formulas/${id}?permanent=true`);
            toast.success("Eliminada definitivamente");
            load();
        } catch {
            toast.error("No se pudo eliminar");
        }
    };

    return (
        <div className="fade-up">
            <PageHeader
                eyebrow={`Papelera · ${items.length}`}
                title="Fórmulas en la papelera"
                lead="Aquí están las fórmulas que has eliminado del catálogo activo. Restáuralas o elimínalas definitivamente."
            >
                <div className="mt-4">
                    <Link to="/formulas" className="text-sm text-[var(--ink-2)] inline-flex items-center gap-1 hover:text-[var(--ink)]">
                        <ArrowLeft size={14}/> Volver a fórmulas
                    </Link>
                </div>
            </PageHeader>

            <div className="px-8 md:px-12 py-8 max-w-6xl">
                {loading ? (
                    <div className="text-[var(--ink-3)] py-8 text-center">cargando…</div>
                ) : items.length === 0 ? (
                    <div className="border hairline bg-white p-12 text-center text-[var(--ink-3)]" data-testid="trash-empty">
                        La papelera está vacía.
                    </div>
                ) : (
                    <div className="surface overflow-x-auto" data-testid="trash-list">
                        <table className="data-table w-full">
                            <thead><tr><th>Fórmula</th><th>Objetivo</th><th>Composición</th><th>Eliminada</th><th></th></tr></thead>
                            <tbody>
                                {items.map((f) => (
                                    <tr key={f.id} data-testid={`trash-row-${f.id}`}>
                                        <td>
                                            <span className="font-medium text-[var(--ink-2)]">{f.title}</span>
                                            {f.status === "generating" && <span className="ml-2 text-xs text-[var(--ink-3)] mono">(generación inacabada)</span>}
                                            {f.status === "error" && <span className="ml-2 text-xs text-[var(--terra-2)] mono">(error)</span>}
                                        </td>
                                        <td className="text-[var(--ink-2)] text-xs">{f.objective}</td>
                                        <td className="text-xs mono text-[var(--ink-3)] max-w-[260px] truncate">{(f.components || []).map((c) => `${c.compound_name} ${c.dose_mg}${c.unit||"mg"}`).join(" + ") || "—"}</td>
                                        <td className="mono text-xs text-[var(--ink-3)]">{f.deleted_at ? new Date(f.deleted_at).toLocaleString("es-ES", {dateStyle:"short",timeStyle:"short"}) : "—"}</td>
                                        <td>
                                            <div className="flex items-center gap-2">
                                                <button onClick={() => restore(f.id)} className="px-2.5 py-1 border hairline text-xs bg-white hover:bg-[var(--cream)] inline-flex items-center gap-1" data-testid={`trash-restore-${f.id}`}>
                                                    <ArrowCounterClockwise size={12}/> Restaurar
                                                </button>
                                                <button onClick={() => purge(f.id, f.title)} className="px-2.5 py-1 border hairline text-xs bg-white hover:bg-[var(--cream)] text-[var(--terra-2)] inline-flex items-center gap-1" data-testid={`trash-purge-${f.id}`}>
                                                    <Trash size={12}/> Eliminar
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}
